import PropertyInterface from '@shared/types/property';

export const addressFormatter = (property: PropertyInterface | undefined) =>
  property?.address?.flat + ' ' + property?.address?.postCode;
